import React from 'react';
import { motion } from 'framer-motion';

const HeroSection = ({ companyInfo }) => {
  const scrollToServices = () => {
    const element = document.getElementById('services');
    if (element) {
      const offset = 80;
      const elementPosition = element.offsetTop - offset;
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  // Trusted companies data - this could come from API in the future
  const trustedCompanies = [
    'InnovateCorp',
    'QuantumLeap', 
    'ApexGlobal',
    'Stellar Inc.',
    'Nexus'
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.6,
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: 'easeOut' }
    }
  };

  return (
    <section id="home" className="hero-bg text-white relative overflow-hidden">
      {/* Main Hero Content */}
      <div className="container mx-auto px-6 pt-32 md:pt-48 pb-20 text-center relative z-10">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="max-w-5xl mx-auto"
        >
          <motion.h1 
            variants={itemVariants}
            className="text-4xl md:text-6xl lg:text-7xl font-poppins font-bold leading-tight mb-6"
          >
            Engineering Global Solutions.
            <br />
            <span className="text-lion-yellow">Powering The Future.</span>
          </motion.h1>
          
          <motion.p 
            variants={itemVariants}
            className="text-lg md:text-xl lg:text-2xl text-gray-300 max-w-4xl mx-auto mb-10 leading-relaxed"
          >
            {companyInfo?.description || 
             'LionTek is a world-class technology firm leveraging AI, enterprise software, and cybersecurity to drive innovation for businesses worldwide.'}
          </motion.p>
          
          <motion.div 
            variants={itemVariants}
            className="flex flex-col sm:flex-row justify-center items-center gap-4"
          >
            <button
              onClick={scrollToServices}
              className="w-full sm:w-auto bg-lion-yellow text-lion-blue font-bold py-4 px-8 rounded-lg hover:bg-yellow-300 transition-all duration-300 transform hover:scale-105 btn-glow text-lg"
            >
              Explore Our Services
            </button>
          </motion.div>
        </motion.div>
      </div>

      {/* Trusted By Section */}
      <div className="py-16 border-t border-white/10">
        <div className="container mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.8 }}
          >
            <p className="text-center text-gray-400 text-sm font-bold uppercase tracking-wider mb-8">
              Trusted by Industry Leaders
            </p>
            
            {/* Scrolling animation for company names */}
            <div className="relative h-16 overflow-hidden">
              <div className="absolute top-0 left-0 flex w-max animate-scroll">
                {/* Duplicate the array to create seamless loop */}
                {[...trustedCompanies, ...trustedCompanies].map((company, index) => (
                  <div 
                    key={index}
                    className="flex items-center justify-center w-64 mx-4"
                  >
                    <p className="text-2xl font-poppins text-gray-300 opacity-60 hover:opacity-80 transition-opacity duration-300">
                      {company}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Background decorative elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-lion-yellow rounded-full opacity-30 animate-pulse"></div>
        <div className="absolute top-3/4 right-1/4 w-1 h-1 bg-white rounded-full opacity-20 animate-pulse" style={{ animationDelay: '1s' }}></div>
        <div className="absolute bottom-1/4 left-1/3 w-1.5 h-1.5 bg-lion-yellow rounded-full opacity-25 animate-pulse" style={{ animationDelay: '2s' }}></div>
      </div>
    </section>
  );
};

export default HeroSection;